import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/new-product/")({
  head: () => pageHead({ title: 'New RVs', description: 'Shop new RVs for sale at Rex & Sons RVs near Wilmington, NC.', path: '/new-product' }),
  beforeLoad: () => {
    throw redirect({ href: "/rv-search?condition=new" });
  },
});